import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './XTool.css';

const XAdvancedOptions = ({
    timeValue,
    setTimeValue,
    timeDropdownText,
    dateMin,
    setDateMin,
    dateMax,
    setDateMax,
    blockHashtags,
    setBlockHashtags,
    blockLinks,
    setBlockLinks,
    onlyPopularPosts,
    setOnlyPopularPosts,
    minFaves,
    setMinFaves,
    banListString,
    handleBanListChange,
    onClose
}) => {
    const [showCustomDate, setShowCustomDate] = useState(timeValue === -1);

    // Handle time option selection
    const handleTimeOptionClick = (value) => {
        setTimeValue(value);
        setShowCustomDate(value === -1);
    };

    return (
        <div className="xtool-advanced-options-container">
            <div className="xtool-advanced-header">
                <h2>Advanced Search Options</h2>
                <button className="xtool-close-button" onClick={onClose}>
                    <CloseIcon />
                </button>
            </div>

            <div className="xtool-options-section">
                <h3>Time Range</h3>
                <div className="xtool-time-options">
                    <button 
                        className={`xtool-time-option ${timeValue === 0 ? 'xtool-active' : ''}`}
                        onClick={() => handleTimeOptionClick(0)}
                    >
                        All Time
                    </button>
                    <button 
                        className={`xtool-time-option ${timeValue === 1 ? 'xtool-active' : ''}`}
                        onClick={() => handleTimeOptionClick(1)}
                    >
                        Past Day
                    </button>
                    <button 
                        className={`xtool-time-option ${timeValue === 7 ? 'xtool-active' : ''}`}
                        onClick={() => handleTimeOptionClick(7)}
                    >
                        Past Week
                    </button>
                    <button 
                        className={`xtool-time-option ${timeValue === 30 ? 'xtool-active' : ''}`}
                        onClick={() => handleTimeOptionClick(30)}
                    >
                        Past Month
                    </button>
                    <button 
                        className={`xtool-time-option ${timeValue === 365 ? 'xtool-active' : ''}`}
                        onClick={() => handleTimeOptionClick(365)}
                    >
                        Past Year
                    </button>
                    <button 
                        className={`xtool-time-option ${timeValue === -1 ? 'xtool-active' : ''}`}
                        onClick={() => handleTimeOptionClick(-1)}
                    >
                        Custom Range
                    </button>
                </div>
                
                {showCustomDate && (
                    <div className="xtool-custom-date">
                        <div className="xtool-date-input">
                            <label htmlFor="date-min">From:</label>
                            <input 
                                id="date-min"
                                type="date" 
                                value={dateMin || ''} 
                                onChange={(e) => setDateMin(e.target.value)}
                            />
                        </div>
                        <div className="xtool-date-input">
                            <label htmlFor="date-max">To:</label>
                            <input 
                                id="date-max"
                                type="date" 
                                value={dateMax || ''} 
                                onChange={(e) => setDateMax(e.target.value)}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="xtool-options-section">
                <h3>Filter Options</h3>
                <div className="xtool-checkbox-options">
                    <label className="xtool-checkbox-label">
                        <input 
                            type="checkbox" 
                            checked={blockHashtags}
                            onChange={() => setBlockHashtags(!blockHashtags)}
                        />
                        <span className="xtool-checkmark"></span>
                        Block hashtag spam
                    </label>
                    <label className="xtool-checkbox-label">
                        <input 
                            type="checkbox" 
                            checked={blockLinks}
                            onChange={() => setBlockLinks(!blockLinks)}
                        />
                        <span className="xtool-checkmark"></span>
                        Block posts with links
                    </label>
                    <label className="xtool-checkbox-label">
                        <input 
                            type="checkbox" 
                            checked={onlyPopularPosts}
                            onChange={() => setOnlyPopularPosts(!onlyPopularPosts)}
                        />
                        <span className="xtool-checkmark"></span>
                        Show only posts with likes
                    </label>
                </div>
                
                <div className="xtool-min-faves">
                    <label htmlFor="min-faves">Minimum likes:</label>
                    <input 
                        id="min-faves"
                        type="number" 
                        min="0"
                        value={minFaves} 
                        onChange={(e) => setMinFaves(parseInt(e.target.value) || 0)}
                    />
                </div>
            </div>

            <div className="xtool-options-section">
                <h3>Exclude Words/Phrases</h3>
                <p className="xtool-help-text">Enter words or phrases to exclude, separated by commas</p>
                <textarea 
                    className="xtool-blacklist-input"
                    value={banListString}
                    onChange={handleBanListChange}
                    placeholder="giveaway, airdrops, WIN $10,000, etc."
                    rows={4}
                />
                <p className="xtool-help-text">Common spam words are already filtered out</p>
            </div>
        </div>
    );
};

export default XAdvancedOptions; 